import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Collapse,
  styled,
  Drawer as MuiDrawer,
  Tooltip,
  ListItemIcon,
  ListItemButton,
} from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import {
  FaChartBar,
  FaCogs,
  FaTree,
  FaFileInvoice,
  FaShoppingCart,
  FaUsers,
  FaAppStore,
  FaEdit,
  FaFileAlt,
} from "react-icons/fa";
import { FaBuffer } from "react-icons/fa6";
import { BiSolidDashboard } from "react-icons/bi";
import { FaFileExcel } from "react-icons/fa";
import { IoMdAdd } from "react-icons/io";
import { FaList } from "react-icons/fa";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { MdCategory } from "react-icons/md";
import { HiCollection } from "react-icons/hi";
import { AiOutlineBranches } from "react-icons/ai";
import { CiBookmark } from "react-icons/ci";
import { TbFileTypeXml } from "react-icons/tb";

import { Send } from "@mui/icons-material";
import { AiOutlineUser } from "react-icons/ai";
import { AiTwotoneFileExcel } from "react-icons/ai";
import { MdInventory } from "react-icons/md";
import { MdSync } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import ChatIcon from "@mui/icons-material/Chat";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

export const drawerWidthOpen = 250;
export const drawerWidthCollapsed = 80;

const getDrawerItems = (applications) => {
  // MarketPlaceId'lere göre yetkileri kontrol et
  const hasXmlDealer = applications.some(
    (app) => app.SpecialApplicationId === 1
  );
  const hasStockTracking = applications.some(
    (app) => app.SpecialApplicationId === 2
  );
  const hasProductManagement = applications.some(
    (app) => app.SpecialApplicationId === 6
  );
  const hasInvoiceManagement = applications.some(
    (app) => app.SpecialApplicationId === 7
  );
  const hasYayilim = applications.some(
    (app) => app.SpecialApplicationId === 8
  );

  const getTooltipMessage = (disabled) => {
    return disabled
      ? "Mağaza sayfasından bu uygulamayı açabilir veya talep oluşturup satın alabilirsiniz"
      : "";
  };

  const baseDrawerItems = [
    {
      text: "Dashboard",
      icon: <BiSolidDashboard />,
      path: "/",
      disabled: false,
      tooltip: getTooltipMessage(false),
    },
    {
      text: "Siparişler",
      icon: <FaShoppingCart />,
      subItems: [
        {
          text: "Sipariş Listesi",
          icon: <FaList />,
          path: "/orders",
          disabled: false,
          tooltip: getTooltipMessage(false),
        },
        {
          text: "Sipariş Raporları",
          icon: <FaChartBar />,
          path: "/order-reports",
          disabled: false,
          tooltip: getTooltipMessage(false),
        },
      ],
      disabled: false,
      tooltip: getTooltipMessage(false),
    },
    // {
    //   text: "Fatura",
    //   icon: <FaFileInvoice />,
    //   path: "invoices",
    //   disabled: !hasInvoiceManagement,
    //   tooltip: getTooltipMessage(!hasInvoiceManagement),
    // },
      {
      text: "Faturalar",
      icon: <FaFileInvoice />,
      subItems: [
        {
          text: "Fatura Listesi",
          icon: <FaList />,
          path: "/invoices",
          disabled: false,
          tooltip: getTooltipMessage(false),
        },
        {
          text: "Fatura Müşterileri",
          icon: <FaUsers />,
          path: "/invoiceCustomers",
          disabled: false,
          tooltip: getTooltipMessage(false),
        },
      ],
      disabled: false,
      tooltip: getTooltipMessage(false),
    },
    {
      text: "Ürün Yönetimi",
      icon: <FaBuffer />,
      subItems: [
        {
          text: "Ürün Ekleme",
          icon: <IoMdAdd />,
          path: "add-product",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Ürün Listesi",
          icon: <FaList />,
          path: "products",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Pazaryeri Ürünleri",
          icon: <FaStore />,
          path: "PlaceProducts",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Kategori Ağacı",
          icon: <MdCategory />,
          subItems: [
            {
              text: "Kategoriler",
              icon: <MdCategory />,
              path: "/categorys",
              disabled: !hasProductManagement,
              tooltip: getTooltipMessage(!hasProductManagement),
            },
            {
              text: "Fiyat Kuralları",
              icon: <FaChartBar />,
              path: "/price-rules",
              disabled: !hasProductManagement,
              tooltip: getTooltipMessage(!hasProductManagement),
            },
          ],
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Markalar",
          icon: <CiBookmark />,
          path: "sellerbrand",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
        {
          text: "Varyant Eşleştir",
          icon: <AiOutlineBranches />,
          path: "/categoryVariant",
          disabled: !hasProductManagement,
          tooltip: getTooltipMessage(!hasProductManagement),
        },
      ],
      disabled: !hasProductManagement,
      tooltip: getTooltipMessage(!hasProductManagement),
    },
    {
      text: "Toplu İşlemler",
      icon: <HiCollection />,
      subItems: [
        {
          text: "Fiyat Güncelle",
          icon: <FaList />,
          path: "batch-processes",
          disabled: !hasProductManagement,
        },
         {
          text: "Başlık & Açıklama Güncelle",
          icon: <FaEdit />,
          path: "batch-text-processes",
          disabled: !hasProductManagement,
        },
        {
          text: "Ürün Gönderim",
          icon: <Send />,
          path: "sendProductBulk",
          disabled: !hasProductManagement,
        },
      ],
      disabled: !hasProductManagement,
    },
    {
      text: "Excel",
      icon: <FaFileExcel />,
      path: "excelproduct",
      disabled: !hasProductManagement,
    },
    {
      text: "Mesajlar",
      icon: <ChatIcon />,
      path: "questions",
      disabled: false,
    },
    {
      text: "Taleplerim",
      icon: <AssignmentIcon />,
      path: "user-tasks",
      disabled: false,
    },
    {
      text: "XML",
      icon: <TbFileTypeXml />,
      path: "XmlProductSource",
      disabled: !hasProductManagement,
    },
    {
      text: "XML Bayilik",
      icon: <AiTwotoneFileExcel />,
      subItems: [
        {
          text: "Kullanıcılar",
          icon: <AiOutlineUser />,
          path: "xmlDealerUsersPage",
          disabled: !hasXmlDealer,
        },
        {
          text: "XML",
          icon: <TbFileTypeXml />,
          path: "xmldealer",
          disabled: !hasXmlDealer,
        },
      ],
      disabled: !hasXmlDealer,
    },
    {
      text: "Senkronizasyon",
      icon: <MdSync />,
      subItems: [
        {
          text: "Stok Takibi",
          icon: <MdInventory />,
          path: "Stock",
          disabled: !hasStockTracking,
        },
        {
          text: "Yayılım",
          icon: <MdSync />,
          path: "product-sync",
          disabled: !hasYayilim,
          tooltip: getTooltipMessage(!hasYayilim),
        },
      ],
      disabled: !hasStockTracking && !hasYayilim,
    },
    {
      text: "Mağaza",
      icon: <FaAppStore />,
      path: "Application",
      disabled: false,
    },
  ];

  return baseDrawerItems;
};

const DrawerStyled = styled(MuiDrawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: drawerWidthOpen,
    backgroundColor: "#FAFAFA",
    color: "#424242",
    transition: "width 0.3s",
    borderRight: "2px solid #E3F2FD",
    boxShadow: "2px 0 8px rgba(13, 71, 161, 0.08)",
    borderRadius: "0 16px 16px 0",
    borderLeft: "none",
  },
}));

const MobileDrawer = styled(MuiDrawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: "100%",
    backgroundColor: "#FAFAFA",
    color: "#424242",
    transition: "transform 0.3s",
    borderRight: "2px solid #E3F2FD",
    boxShadow: "2px 0 8px rgba(13, 71, 161, 0.08)",
    borderRadius: "0 16px 16px 0",
    borderLeft: "none",
  },
}));

const Drawer = ({ drawerOpen, handleDrawerToggle, handleItemClick, trainingTargetPath }) => {
  const [openSubMenu, setOpenSubMenu] = useState({});
  const [menuItems, setMenuItems] = useState([]);
  const token = useSelector((state) => state?.auth?.user?.accessToken.token);
  const location = useLocation();

  const toggleSubMenu = (text) => {
    setOpenSubMenu((prev) => ({
      ...prev,
      [text]: !prev[text],
    }));
  };

  const collectParentMenusForPath = (items, targetPath, parentKeys = []) => {
    for (const item of items) {
      const normalizedItemPath = item.path
        ? item.path.startsWith("/")
          ? item.path
          : `/${item.path}`
        : null;

      if (normalizedItemPath && normalizedItemPath === targetPath) {
        return parentKeys;
      }

      if (item.subItems?.length) {
        const found = collectParentMenusForPath(
          item.subItems,
          targetPath,
          [...parentKeys, item.text]
        );
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const ListItemStyled = styled(ListItem)(({ theme }) => ({
    borderRadius: "8px",
    margin: "5px 10px",
    padding: "10px",
    "&:hover": {
      backgroundColor: "#eef2f6",
    },
    transition: "background-color 0.3s",
  }));

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const applications = decoded[
          "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
        ]
          .map((roleString) => {
            try {
              return JSON.parse(roleString);
            } catch (parseError) {
              console.error("Role parsing error:", parseError);
              return null;
            }
          })
          .filter((item) => item !== null);

        const menuItems = getDrawerItems(applications);
        setMenuItems(menuItems);
      } catch (error) {
        console.error("Token çözme hatası:", error);
        setMenuItems(getDrawerItems([]));
      }
    } else {
      setMenuItems(getDrawerItems([]));
    }
  }, [token]);

  const trainingParentKeys = useMemo(() => {
    if (!trainingTargetPath || menuItems.length === 0) {
      return [];
    }
    const result = collectParentMenusForPath(menuItems, trainingTargetPath);
    return result || [];
  }, [trainingTargetPath, menuItems]);

  useEffect(() => {
    if (!trainingParentKeys.length) {
      return;
    }
    setOpenSubMenu((prev) => {
      const next = { ...prev };
      trainingParentKeys.forEach((key) => {
        next[key] = true;
      });
      return next;
    });
  }, [trainingParentKeys]);

  useEffect(() => {
    if (!trainingTargetPath) {
      return;
    }

    const timer = setTimeout(() => {
      const targets = document.querySelectorAll('[data-training-target="true"]');
      const visibleTarget = Array.from(targets).find(
        (element) => element.offsetParent !== null
      );

      if (visibleTarget) {
        visibleTarget.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 120);

    return () => clearTimeout(timer);
  }, [trainingTargetPath, openSubMenu, drawerOpen]);

  // Aktif sayfayı kontrol et
  const isActive = (itemPath) => {
    if (!itemPath) return false;
    const currentPath = location.pathname;
    // Path'leri normalize et
    const normalizedItemPath = itemPath.startsWith('/') ? itemPath : `/${itemPath}`;
    const normalizedCurrentPath = currentPath.endsWith('/') && currentPath !== '/' 
      ? currentPath.slice(0, -1) 
      : currentPath;
    
    // Tam eşleşme veya alt sayfa kontrolü
    return normalizedCurrentPath === normalizedItemPath || 
           normalizedCurrentPath.startsWith(normalizedItemPath + '/');
  };

  // Recursive olarak menüleri render eden fonksiyon
  const renderMenuItems = (items, level = 0) => {
    return items.map(({ text, icon, path, subItems, disabled, tooltip }) => {
      const active = isActive(path);
      const normalizedItemPath = path
        ? path.startsWith("/")
          ? path
          : `/${path}`
        : null;
      const isTrainingTarget =
        Boolean(trainingTargetPath) && normalizedItemPath === trainingTargetPath;
      return (
      <React.Fragment key={text}>
        <Tooltip title={tooltip || ""} placement="right" arrow>
          <div>
            <ListItemButton
              data-training-target={isTrainingTarget ? "true" : undefined}
              onClick={() => {
                if (!disabled) {
                  if (subItems) {
                    toggleSubMenu(text);
                  } else {
                    handleItemClick(path);
                    // Close drawer on mobile/tablet when clicking a menu item
                    if (window.innerWidth < 900) {
                      // md breakpoint
                      handleDrawerToggle();
                    }
                  }
                }
              }}
              sx={{
                pl: 2 + level * 2,
                justifyContent: drawerOpen ? "flex-start" : "center",
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? "not-allowed" : "pointer",
                backgroundColor: active ? "#E3F2FD" : "transparent",
                color: active ? "#1565C0" : "#424242",
                borderLeft: active ? "4px solid #1565C0" : "4px solid transparent",
                ...(isTrainingTarget && {
                  backgroundColor: "#fff7ed",
                  borderLeft: "4px solid #f59e0b",
                  color: "#b45309",
                  boxShadow: "0 0 0 1px #fed7aa inset",
                }),
                borderRadius: "10px",
                margin: "4px 8px",
                "&:hover": {
                  backgroundColor: isTrainingTarget
                    ? "#ffedd5"
                    : active
                    ? "#BBDEFB"
                    : "#E3F2FD",
                  color: isTrainingTarget
                    ? "#9a3412"
                    : active
                    ? "#0D47A1"
                    : "#1565C0",
                },
                transition: "all 0.2s ease-in-out",
                fontWeight: active || isTrainingTarget ? 600 : 400,
              }}
              disabled={disabled}
            >
              <IconButton 
                style={{ 
                  minWidth: 40, 
                  fontSize: "1.2rem",
                  color: isTrainingTarget
                    ? "#b45309"
                    : active
                    ? "#1565C0"
                    : "inherit",
                }}
              >
                {icon}
              </IconButton>
              {drawerOpen && (
                <ListItemText 
                  primary={text}
                  secondary={
                    isTrainingTarget ? "Bu sayfa burada" : undefined
                  }
                  primaryTypographyProps={{
                    sx: {
                      fontWeight: active ? 600 : 400,
                      color: isTrainingTarget
                        ? "#b45309"
                        : active
                        ? "#1565C0"
                        : "inherit",
                    }
                  }}
                  secondaryTypographyProps={{
                    sx: {
                      color: "#c2410c",
                      fontWeight: 600,
                      fontSize: "0.72rem",
                    },
                  }}
                />
              )}
              {isTrainingTarget && drawerOpen && (
                <ArrowRightAltIcon
                  sx={{ color: "#b45309", fontSize: "1.2rem", ml: 0.5 }}
                />
              )}
              {subItems &&
                drawerOpen &&
                (openSubMenu[text] ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>
          </div>
        </Tooltip>
        {subItems && (
          <Collapse in={openSubMenu[text]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {renderMenuItems(subItems, level + 1)}
            </List>
          </Collapse>
        )}
      </React.Fragment>
      );
    });
  };

  return (
    <>
      {/* Desktop Drawer */}
      <DrawerStyled
        variant="persistent"
        anchor="left"
        open={true}
        sx={{
          display: { xs: "none", md: "block" },
          width: drawerOpen ? drawerWidthOpen : drawerWidthCollapsed,
          "& .MuiDrawer-paper": {
            width: drawerOpen ? drawerWidthOpen : drawerWidthCollapsed,
          },
        }}
      >
        <Box role="presentation">
          <List sx={{ marginTop: "60px" }}>{renderMenuItems(menuItems)}</List>
          <Divider />
        </Box>
      </DrawerStyled>

      {/* Mobile Drawer */}
      <MobileDrawer
        variant="temporary"
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: "100%",
            transform: drawerOpen ? "none" : "translateX(-100%)",
            transition: "transform 0.3s ease-in-out",
          },
        }}
      >
        <Box
          role="presentation"
          sx={{
            height: "100%",
            overflow: "auto",
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "4px",
            },
          }}
        >
          <List
            sx={{
              marginTop: "70px",
              padding: "0 8px",
            }}
          >
            {renderMenuItems(menuItems)}
          </List>
          <Divider />
        </Box>
      </MobileDrawer>
    </>
  );
};

Drawer.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  handleItemClick: PropTypes.func.isRequired,
  trainingTargetPath: PropTypes.string,
};

Drawer.defaultProps = {
  trainingTargetPath: null,
};

export { Drawer };
